import { Injectable } from "@angular/core";
import { UserInfo } from "../user.info";
import { LocalstorageService } from "./localstorage.service";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { MasterService } from "../../modules/master/services";

@Injectable()
export class UserService {
	private userInfoKey = "userInfo";

	constructor(private localStorage: LocalstorageService, private masterService: MasterService) {}

	private subject = new Subject<any>();

	getCurrentUser(): UserInfo {
		var user: UserInfo;
		user = this.localStorage.getItem(this.userInfoKey);
		if (user) {
			if (!user.c_date) {
				this.setCurrentUser(null);
				return null;
			}

			try {
				var applicationItem = this.masterService.getCurrentApplicationItem();

				user.ApplicationItemID = applicationItem.ApplicationItemID;

				if (user.ApplicationItemID == undefined || user.ApplicationItemID.length != 36) {
					user.ApplicationItemID = "";
				}
			} catch (e) {
				e.toString();
				user.ApplicationItemID = "";
			}
		}

		this.subject.next({ user });

		return user;
	}
	setCurrentUser(user: UserInfo) {
		this.localStorage.setItem(this.userInfoKey, user);
		this.subject.next({ user });
	}

	CheckCurrentUser(): Observable<any> {
		return this.subject.asObservable();
	}
}
